/* eslint-disable */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './index.less';
import copy from 'clipboard-copy'
@inject('dashboardStore')
@observer
class JumpPc extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	}
	componentDidMount() {

	}

	shareOut = async (url) => {
		copy(url)
	};


	//banner图和活动规则的展示
	render() {
		return (
			<div className="jump-pc-h5-wrap">
				<div className="jump-pc-h5">
					<div className="jump-top">
						{window.tms.moduleinfo.h5FirstCombo?
							<div className="jump-top-title"><span className="jump-top-desc-left">{window.tms.moduleinfo.h5FirstCombo}</span><span className="jump-top-desc-right">种套餐</span></div>
							:
							null
						}
						<div className="jump-top-title"><span className="jump-top-desc-left">{window.tms.moduleinfo.h5FirstProduct}</span><span className="jump-top-desc-right">款产品</span></div>
						<div className="jump-top-title"><span className="jump-top-desc-left">{window.tms.moduleinfo.h5FirstDiscount}</span><span className="jump-top-desc-right">折起</span></div>
					</div>
					<div className="jump-bottom">
						<p className="first-desc">本活动仅能在电脑端参与，</p>
						<p className="second-desc">您可以点此<span className="jump-desc" onClick={() => this.shareOut('https://promotion.aliyun.com/ntms/act/package-refund.html')}>复制活动链接</span>并用电脑浏览器打开</p>
					</div>
				</div>
			</div>
		);
	}
}

export default JumpPc;


// WEBPACK FOOTER //
// ./src/scripts/components/JumpPc/h5.js